import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Layout,
  theme,
  Tabs,
  Row,
  Col,
  Card,
  Button,
  Input,
  message,
} from "antd";
import { FileTextOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import type { TabsProps } from "antd";
import LoadingOverlay from "react-loading-overlay-ts";
import dayjs from "dayjs";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";

import "../../styles/GroupManagement.css";
import FuneralPaymentTable from "../../components/Table/Funeral/FuneralPaymentTable";
import { getFuneralInvoiceApi } from "../../services/Funeral/FuneralInvoiceApis";
import { addFuneralTransactionApi } from "../../services/Funeral/FuneralTransactionApis";

const { Content } = Layout;
const { Search } = Input;

interface PaymentType {
  Type: string;
  AccountName: string;
  AccountNumber: string;
  AccountType: string;
  BranchCode: string;
  PaymentDate: string;
}

const FuneralManagementPage: React.FC = () => {
  const navigate = useNavigate();

  const { invoiceId }: any = useParams();
  const [invoice, setInvoice] = useState<any>({});
  const [payment, setPayment] = useState<PaymentType>({
    Type: "N/A",
    AccountName: "N/A",
    AccountNumber: "N/A",
    AccountType: "N/A",
    BranchCode: "N/A",
    PaymentDate: "N/A",
  });
  const [payments, setPayments] = useState<any>([]);
  const [isActive, setActive] = useState(true);

  const onChange = (key: string) => {
    console.log(key);
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleAddTransaction = async (data: any, invoiceId: any) => {
    setActive(true);

    return await addFuneralTransactionApi(invoiceId, data)
      .then((res) => {
        setPayments([...payments, res.data]);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleBack = () => {
    navigate("/funeral-invoices");
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: <span style={{ minWidth: "80px", display: "inline-block", textAlign: "center" }}>Info</span>,
      children: (
        <Row style={{ paddingTop: "24px" }} gutter={[24, 24]}>
          <Col span={12}>
            <Card
              title="Customer Info"
              style={{ backgroundColor: "	#DCDCDC", height: "100%" }}
              bordered={true}
              hoverable={true}
            >
              <div className="card-content">
                <h4>Name:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.Name}
                </span>
              </div>
              <div className="card-content">
                <h4>Surname:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.Surname}
                </span>
              </div>
              <div className="card-content">
                <h4>ID Number:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.IdNumber}
                </span>
              </div>
              <div className="card-content">
                <h4>Cellphone:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.Cellphone}
                </span>
              </div>
              <div className="card-content">
                <h4>Address Line 1:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.AddressLine1}
                </span>
              </div>
              <div className="card-content">
                <h4>Address Line 2:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.AddressLine2}
                </span>
              </div>
              <div className="card-content">
                <h4>Postal Code:</h4>
                <span>
                  {" "}
                  {invoice &&
                    invoice.FuneralCustomer &&
                    invoice.FuneralCustomer.PostalCode}
                </span>
              </div>
            </Card>
          </Col>

          <Col span={12}>
            <Card
              title="Invoice Info"
              style={{ backgroundColor: "	#DCDCDC", height: "100%" }}
              bordered={true}
              hoverable={true}
            >
              <div className="card-content">
                <h4>Type:</h4>
                <span> {invoice && invoice.Type}</span>
              </div>
              <div className="card-content">
                <h4>Outstanding Balance:</h4>
                <span>R {invoice && invoice.OutstandingBalance}</span>
              </div>
              <div className="card-content">
                <h4>Date Captured:</h4>
                <span>
                  {" "}
                  {invoice && dayjs(invoice.Date).format("YYYY-MM-DD")}
                </span>
              </div>
              <div className="card-content">
                <h4>Group Name:</h4>
                <span>
                  {" "}
                  {invoice && invoice.Group && invoice.Group.GroupName}
                </span>
              </div>
              <div className="card-content">
                <h4>Address Line 1:</h4>
                <span>
                  {" "}
                  {invoice && invoice.Group && invoice.Group.AddressLine1}
                </span>
              </div>
              <div className="card-content">
                <h4>Address Line 2:</h4>
                <span>
                  {" "}
                  {invoice && invoice.Group && invoice.Group.AddressLine2}
                </span>
              </div>
              <div className="card-content">
                <h4>Postal Code:</h4>
                <span>
                  {" "}
                  {invoice && invoice.Group && invoice.Group.PostalCode}
                </span>
              </div>
            </Card>
          </Col>
        </Row>
      ),
    },
    {
      key: "2",
      label: <span style={{ minWidth: "80px", display: "inline-block", textAlign: "center" }}>Payments</span>,
      children: (
        <FuneralPaymentTable
          payments={payments}
          invoice={invoice}
          invoiceId={invoiceId}
          handleAdd={handleAddTransaction}
        />
      ),
    },
  ];

  useEffect(() => {
    getFuneralInvoiceApi(String(invoiceId))
      .then((res) => {
        setInvoice(res.data);
        setPayments(res.data.FuneralTransaction);
        setActive(false);
      })
      .catch((err) => {
        console.log(err);
        setActive(false);
      });

    setActive(false);
  }, []);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <FileTextOutlined
                  style={{
                    paddingRight: "5px",
                    color: "#f04f05",
                  }}
                />
                {invoice.InvoiceNumber
                  ? invoice.InvoiceNumber
                  : invoice.QuoteNumber}
              </h2>
              <div className="interactions">
                <Button onClick={handleBack} size="large">
                  <ArrowLeftOutlined style={{ paddingRight: "5px" }} />
                  Back
                </Button>
              </div>
              <Tabs type="card" defaultActiveKey="1" items={items} onChange={onChange} />
            </div>
          </Content>
        </Layout>
      </Layout>
    </LoadingOverlay>
  );
};

export default FuneralManagementPage;
